<template>
  <v-col cols="12" class="gap2">
    <div>
      <p class="font-weight-medium grey--text mb-2">
        <span class="text--darken-2">Création d'agent rapide</span>
      <span v-if="intoAgency" class="caption font-weight-regular text--lighten-2 ml-2">associé à cette agence</span>
      </p>
      <v-row dense>
        <v-col cols="3">
          <v-text-field
              ref="quickFirstname"
              class="quick-input"
              :value="value.firstname"
              label="Prénom"
              dense
              outlined
              hide-details
              @input="val => updateField('firstname', val)"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
              :value="value.lastname"
              class="quick-input"
              label="Nom"
              dense
              outlined
              hide-details
              @input="val => updateField('lastname', val)"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
              :value="value.email"
              class="quick-input"
              label="Email"
              dense
              outlined
              hide-details
              @input="val => updateField('email', val)"
          />
        </v-col>
        <v-col cols="3">
          <div class="d-flex quick-form-actions">
            <v-btn
                icon
                class="sas-action-btn"
                @click.stop="confirmForm"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
                icon
                class="sas-action-btn"
                @click.stop="$emit('cancel')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <div>
      <div class="d-flex items-center" v-if="wildAgent">
        <p class="font-weight-medium grey--text mt-4 mb-2">
          <span class="text--darken-2">Nom de l'agence</span>
          <span class="caption font-weight-regular text--lighten-2 ml-1">saisie rapide</span>

        </p>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small color="grey lighten-1">mdi-information-outline</v-icon>
            </template>
            <span>Ce nom aidera à <span class="font-weight-bold">retrouver ou créer l'agence</span> au moment de la clôture du workshop.</span>
          </v-tooltip>
        </div>
      <v-row dense v-if="wildAgent">
        <v-col cols="3">
          <v-text-field
              ref="quickAgencyName"
              class="quick-input"
              :value="value.agencyName"
              label="Agence"
              dense
              outlined
              hide-details
              @input="val => updateField('agencyName', val)"
          />
        </v-col>
      </v-row>
        </div>

  </div>
  </v-col>
</template>


<script>

export default {
  name: "QuickAgentForm",
  components: {  },
  props: {
    value: { type: Object, required: true },
    listenKeyboard: { type: Boolean, default: false},
    intoAgency: { type: Boolean, default: false},
    wildAgent: { type: Boolean, default: false}, // [N] A quickAgent without related agency
  },
  emits: ["input", "confirm", "cancel"],
  mounted() {
    this.focusFirstname()
    if (this.listenKeyboard) {
      window.addEventListener("keydown", this.handleKeydown)
    }
  },
  beforeDestroy() {
    if (this.listenKeyboard) {
      window.removeEventListener("keydown", this.handleKeydown)
    }
  },
  methods: {
    confirmForm() {
      if (this.value.firstname.trim().length === 0
          && this.value.lastname.trim().length === 0
          && this.value.email.trim().length === 0 ) {
        this.$emit('cancel')
      } else {
        this.$emit('confirm')
      }
    },
    updateField(field, val) {
      this.$emit('input', {
        ...this.value,
        [field]: val
      })
    },
    focusFirstname() {
      this.$nextTick(() => {
        const input = this.$refs.quickFirstname

        if (input && typeof input.focus === "function") {
          input.focus()
        }
      })
    },
    handleKeydown(e) {
      // [N] Utilisé si 'listenKeyboard' est 'true'
      // (pour éviter conflits si le parent écoute aussi les clavier)
      if (e.key === "Escape") {
        e.preventDefault()
        e.stopImmediatePropagation()
        this.$emit('cancel')
      } else if (e.key === "Enter") {
        e.preventDefault()
        e.stopImmediatePropagation()
        this.confirmForm()
      }
    },
  }

}
</script>


<style scoped>
.quick-form-actions {
  gap: 4px;
}

.quick-input {

}

.gap2 {
  gap:8px;
}

::v-deep .quick-input.v-text-field--outlined fieldset {
  border-color: #dadce0;
}
::v-deep .quick-input.v-text-field--outlined.v-input--is-focused fieldset {
  border-width: 1px;
}

.sas-action-btn {
    width: 40px;
    height: 40px;
    min-width: 40px !important;
    border-radius: 999px;
    border: 1px solid #dadce0;
    transition: background 0.2s ease, border-color 0.2s ease;
}
</style>